
import React from 'react';

const DepositLedgerTab = () => {
  const deposits = [
    { date: '10/07/2025', amount: 1400, note: 'बिल कपात - ठेव' },
    { date: '20/07/2025', amount: 1500, note: 'बिल कपात - ठेव' },
    { date: '30/07/2025', amount: 1780, note: 'बिल कपात - ठेव' },
  ];

  return (
    <div style={{ padding: '10px' }}>
      <h3 style={{ marginBottom: '10px' }}>ठेव जमा नोंदी</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: '#f2f2f2' }}>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>दिनांक</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>रक्कम (₹)</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>नोंद</th>
          </tr>
        </thead>
        <tbody>
          {deposits.map((entry, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{entry.date}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{entry.amount}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{entry.note}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DepositLedgerTab;
